import { z } from 'zod'

/** Shared search-param schema for the range filter on every report route.
 *  Only the fields relevant to `mode` are meaningful; resolveReportRange()
 *  fills sensible defaults for the rest. */
export const reportRangeSearchSchema = z.object({
  mode: z.enum(['preset', 'month', 'week', 'custom']).default('preset'),
  preset: z.enum(['today', '7d', '30d', '3m', '6m', '1y']).optional(),
  year: z.number().int().min(2000).max(2100).optional(),
  month: z.number().int().min(0).max(11).optional(),
  week: z.number().int().min(1).max(6).optional(),
  from: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
  to: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
})
